import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered mw-600px" }
const _hoisted_4 = { class: "modal-content umt-form" }
const _hoisted_5 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_10 = { class: "d-flex gap-5 mb-3" }
const _hoisted_11 = { class: "fv-row flex-md-root" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Chọn", -1)
const _hoisted_13 = { class: "w-100 text-center mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-success me-3 d-none",
      ref: "call_modal_delete",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_ctx.id}`
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.id,
      ref: "addChooseMajor",
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_select, {
                    "popper-class": "umt-form-dd",
                    class: "form-select-solid w-100",
                    placeholder: "Chọn",
                    filterable: true,
                    modelValue: _ctx.admissionwinnerid,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.admissionwinnerid) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajor, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "btn btn-light m-auto mx-3",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
                }, " Hủy bỏ "),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success m-auto", _ctx.admissionwinnerid ==''?'disabled':'']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitComment()))
                }, " Xác nhận ", 2)
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ], 64))
}